import { saveCartItemLength, saveCartItems } from "@/store/CartStorage";

const CartPlugin = (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === "setCartItemLength") {
      saveCartItemLength(mutation.payload || 0);
    } else if (mutation.type === "saveBagIds") {
      saveCartItems(mutation.payload || []);
    }
  });
};

export default CartPlugin;
